module.exports = __webpack_public_path__ + "img/teacher.020e0661.svg";